import type { PokerMultiTableTournaments } from '@ps/web-martech-cms-types';

import type { WidgetModelConfig } from '@swf/core/store';

import { defaultState } from './defaultState';
import { generateMTTEffects } from './effects';
import { generateMTTReducer } from './reducers/reducers';
import { selectors } from './selectors';
import type { ConfigQueryVariablesPayload, PokerMultiTableTournamentsStateBase } from './types';

export type { PokerMultiTableTournamentsStateBase, ConfigQueryVariablesPayload };

const reducers = generateMTTReducer<PokerMultiTableTournamentsStateBase>(defaultState);
const effects = generateMTTEffects<PokerMultiTableTournaments>();

export interface PokerMultiTableTournamentsWidgetModelBase
  extends WidgetModelConfig<PokerMultiTableTournaments, PokerMultiTableTournamentsStateBase> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

export { generateMTTEffects, generateMTTReducer, selectors as generateMTTSelectors };
